import React from 'react';
import LeadershipPageHeader from '@/components/LeadershipPageHeader';
import RbacPageHero from './RbacPageHero';
import RbacStatStrip from './RbacStatStrip';

/** Hero for admin shell, or light title + stats under FIC chrome. */
export default function RbacScreenIntro({
  lead, title, subtitle, eyebrow = 'IITH Hospital · Access control', actions, stats,
}) {
  if (lead) {
    return (
      <div className="space-y-4">
        <LeadershipPageHeader title={title} subtitle={subtitle} actions={actions} />
        <RbacStatStrip tone="light" items={stats} />
      </div>
    );
  }
  return (
    <RbacPageHero eyebrow={eyebrow} title={title} subtitle={subtitle} actions={actions}>
      <RbacStatStrip items={stats} />
    </RbacPageHero>
  );
}
